module.exports = __webpack_public_path__ + "img/solenawhite_green.48491093.png";